(function () {
  function initFinder(root) {
    if (!root || root.dataset.eazReady === 'true') return;
    root.dataset.eazReady = 'true';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-eaz-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-eaz-panel]'));
    if (!tabs.length || !panels.length) return;

    function activate(key, focus) {
      tabs.forEach(function (tab) {
        var active = tab.getAttribute('data-eaz-tab') === key;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
        if (active && focus) tab.focus();
      });
      panels.forEach(function (panel) {
        var active = panel.getAttribute('data-eaz-panel') === key;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { activate(tab.getAttribute('data-eaz-tab'), false); });
      tab.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp' && event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        var step = (event.key === 'ArrowDown' || event.key === 'ArrowRight') ? 1 : -1;
        var next = (index + step + tabs.length) % tabs.length;
        activate(tabs[next].getAttribute('data-eaz-tab'), true);
      });
    });

    activate(tabs[0].getAttribute('data-eaz-tab'), false);
  }

  function initAll() {
    document.querySelectorAll('[data-eaz-finder]').forEach(initFinder);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', initAll);
})();
